import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import { UserRoot } from './UsuarioLogado';

export enum MODULOS {
  "Geral" = 1,
  "Informe de Vendas" = 2,
  "Controle de Acesso" = 3,
  "Cadastro Lojas" = 4,
  "Boletos e Avisos de Cobrança" = 5,
  "Comunicação" = 6,
  "Arquivo" = 7,
  "Autorização de Serviço" = 8,
  "Ajuda" = 9,
  "Multi" = 10,
  "Configuração"=11, 
  "Encomendas" = 12
}

type IApiResponse = {
  Item: any;
  erro: string;
}
export enum ID_ATIVIDADES {
  "CRIAR_COMUNICADO" = 1,
  "CRIAR_NOTIFICACAO" = 4,
  "CRIAR_PROMOCAO" = 20,
  "CRIAR_SOLICITAÇÃO" = 10,
}

export enum ATIVIDADES {
  "ABRIR_PERIODO" = "Abrir Período",
  "VISUALIZAR_CONTRATOS_RESCINDIDOS" = "Visualizar Contratos Rescindidos",
  "ADMINISTRAR_AUTORIZACAO_DE_SERVICO" = "Administrar Autorização de Serviço",
  "ALTERAR_VENDA" = "Alterar Venda",
  "APROVAR_VENDAS" = "Aprovar Vendas Alteradas",
  "BOLETOS_E_AVISOS_DE_COBRANCA" = "Boletos E Avisos De Cobrança",
  "PRESTACAO_DE_CONTAS" = "Prestação de Contas",
  "NOTA_FISCAL" = "Nota Fiscal - Consulta",
  "NOTA_FISCAL_RESCINDIDOS" = "Nota Fiscal - Contratos Rescindidos",
  "ACESSO_MFA" = "Acesso MFA",
  "CADASTRAR_PRESTACAO_DE_CONTAS" = "Cadastrar Prestação de Contas",
  "CADASTRAR_PERFIL_DE_ACESSO" = "Cadastrar Perfil de Acesso",
  "CONSULTA_DE_BOLETOS_E_AVISOS_DE_COBRANCAS" = "Consulta de Boletos e Avisos de Cobranças",
  "CONSULTAR_COLABORADORES_AUTORIZADOS" = "Consultar Colaboradores Autorizados",
  "CONSULTAR_EXTRATO" = "Consultar Extrato",
  "CONSULTAR_INFORMES_NAO_LANCADOS" = "Consultar Informes Não Lançados",
  "CONSULTAR_LOJAS" = "Consultar Lojas",
  "CONTROLE_DE_ACESSO_LOJISTA" = "Controle de Acesso Lojista",
  "CONTROLE_DE_ACESSO_MULTIPLAN" = "Controle de Acesso Multiplan",
  "CRIAR_AUTORIZACAO_DE_SERVICO" = "Criar Autorização de Serviço",
  "CRIAR_COMUNICADO" = "Criar Comunicado",
  "CRIAR_NOTIFICACAO" = "Criar Notificação",
  "CRIAR_PROMOCAO" = "Criar Promoção",
  "CRIAR_SOLICITAÇÃO" = "Criar Solicitação",
  "CRIAR_PROMPT_IA_COMUNICACAO" = "Criar Prompt IA",
  "DASHBOARD_INICIAL" = "Dashboard Inicial",
  "INFORMAR_VENDA" = "Informar Venda",
  "LER_COMUNICADO" = "Ler Comunicado",
  "LER_NOTIFICACAO_E_SOLICITACAO" = "Ler/Responder Notificação e Solicitação",
  "LER_PROMOCAO" = "Ler/Responder Promoção",
  "LISTAR_AUTORIZACOES_DE_SERVICO_LOJISTA" = "Listar Autorizações de Serviço Lojista",
  "LISTAR_AUTORIZACOES_DE_SERVICO_MULTIPLAN" = "Listar Autorizações de Serviço Multiplan",
  "LOGIN" = "Login",
  "SALVAR_VIDEO" = "Salvar Video",
  "VER_ARQUIVOS" = "Ver Arquivos",
  "INSERIR_ARQUIVOS" = "Inserir arquivo",
  "INSERIR_TIPO_ARQUIVOS" = "Inserir Tipo de Arquivo",
  "VER_DASHBOARD_MULTI" = "Ver Dashboard Multi",
  "VER_AUDITORIA_LOJISTA" = "Ver Auditoria - Lojista",
  "VER_AUDITORIA_MULTIPLAN" = "Ver Auditoria - Multiplan",
  "VER_FORMULARIO_MULTI" = "Ver Formulário de Benefícios",


  "CONFIGURACAO_MODAL_CONSULTA" = "Consulta Modais",
  "CONFIGURACAO_MODAL_CADASTRAR" = "Cadastrar Modal",
  "CONFIGURACAO_MODAL_IMAGEM" = "Imagens Modal",

  "CONFIGURACAO_BANNER_CONSULTA" = "Consulta Banners",
  "CONFIGURACAO_BANNER_CADASTRAR" = "Cadastrar Banner",
  "CONFIGURACAO_BANNER_IMAGEM" = "Imagem Banner",

  "CONFIGURACAO_ENCOMENDA_CONSULTA" = "Consultar Encomendas",
  "CONFIGURACAO_ENCOMENDA_CADASTRAR" = "Registrar Encomendas",
  "CONFIGURACAO_ENCOMENDA_ADMINISTRAR" = "Administrar Encomendas"
  
}

@Injectable()
export class APIService {

  public static API_URL = '';
  public static API_KEY = '';

  public static API_KEY_SEARCH = '';
  public static API_URL_SEARCH = '';

  // telemetria
  public static INSIGHTS; // código do cadastro do dispositivo no Hub
  public static AMBIENTE ;
  public static UPLOAD_VL ;
  public static CHAT_URL ;
  public static GRUPO_VIDEOLIB ;

  public static ATIVIDADES = ATIVIDADES;
  public static ID_ATIVIDADES = ID_ATIVIDADES;
  public static MODULOS = MODULOS;



  // armazenamento offline
  public static storage_key = '';
  public static storage_notificacao = '';

  public static storage_acessos = '';
  public static storage_fingerprint = '';


  public static TIMEOUT;

  // NOTIFICACAO
  public static versao  = '';
  public static APPCANAL  = '';
  public static NOTIF_URI ;
  public static NOTIF_FUNCTIONCODE ;
  public static NOTIF_deviceToken; // código do dispositivo
  public static NOTIF_idHub; // código do cadastro do dispositivo no Hub

  public static NOVO_BANNER;
  public static LINK;
  public static BANNERS=[];

  
  // PUSHER
  public static PUSHER_KEY;
  public static PUSHER_AMBIENTE;
  public static PUSHER_CHANNEL;
  public static PUSHER_CLUSTER;

  public static DatatableMensagens = {
    "emptyMessage": "Nenhum registro encontrado",
    "loadingMessage": "Carregando...",
    totalMessage: 'total',
  }

  public static token;
  public static dataToken;
  public static numeroTokenInformado;

  public static MALLS = [];

  public static TokenJWT = "";

  public static isAdmin;
  public static NOVAS_NOTIFICACOES;
  public static LISTA_NOTIFICACOES=[];

  //Multiplan
  public static MULTIPLAN_IMAGE_HOME;
  public static MULTIPLAN_URL_HOME;
  public static MULTIPLAN_IMAGE_LOGIN;
  public static MULTIPLAN_IMAGE_SENHA;
  public static MULTIPLAN_IMAGE_NEW;

  public static MULTIPLAN_SEGMENTOS = new Map<string, any>();

  public static UsuarioLogado = {
    "TOKENJWT": "",
    "TOKENAUX": "",
    "dataToken": "",
    "Usuario": null as UserRoot

};

public static VisaoUsuario=[];
public static VisaoGeralUsuario = [];
public static ControleAcessos={
  "isVideo":false,
  "isAceite":false,
  "isFingerPrint":false,
}
public static ControleFingerPrint = {
  "fingerLogin": "",
  "fingerPassword": ""
};

  public static clean (obj: any)
  {
    obj = obj.map(v=>{
      v = Object.assign({}, v);
      for( let k in v ) v[k] = "";
      return v;
    });
  }

  /** PARAMTEROS DO LOGIN AD */
  public static APPID="aadf21dd-7908-465d-936c-e51fe10976cc";
  public static TENANT="e27ae7e6-02e0-4721-94fd-7abd7e3fabe6";
  public static PACKAGE_NAME="br.com.multiplan.dev.canallojista";
  public static HASH_ANDROID="ga0RGNYHvNM5d0SLGQfpQWAPGJ8%3D";

  

  /** Indicadores para tela de DASHBOARD */
  public static entradaDashboard=''; /** indicadores possíveis BANNER, MENU */

  public static readonly ENTRADA_MENU = 'menu';
  public static readonly ENTRADA_BANNER = 'banner';



  public static calculaIdade(fromdate:Date) {
    const todate= new Date();

    var age= [], fromdate= new Date(fromdate),
    y= [todate.getFullYear(), fromdate.getFullYear()],
    ydiff= y[0]-y[1],
    m= [todate.getMonth(), fromdate.getMonth()],
    mdiff= m[0]-m[1],
    d= [todate.getDate(), fromdate.getDate()],
    ddiff= d[0]-d[1];

    if(mdiff < 0 || (mdiff=== 0 && ddiff<0))--ydiff;
    if(mdiff<0) mdiff+= 12;
    if(ddiff<0){
        fromdate.setMonth(m[1]+1, 0);
        ddiff= fromdate.getDate()-d[1]+d[0];
        --mdiff;
    }
    if(ydiff> 0) age.push(ydiff+ ' ano'+(ydiff> 1? 's ':' '));
    if(mdiff> 0) age.push(mdiff+ ' mes'+(mdiff> 1? 'es':''));
    if(ddiff> 0) age.push(ddiff+ ' dia'+(ddiff> 1? 's':''));
    if(age.length>1) age.splice(age.length-1,0,' e ');
    return age.join('');
  }


  public static get header() {
    APIService.setTimeOut();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': APIService.UsuarioLogado.TOKENJWT,
      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': APIService.API_KEY
    })
  };

  public static getHeader() {

    APIService.setTimeOut();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.UsuarioLogado.TOKENJWT,
      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': this.API_KEY
    })

  }

  public static  getHeaderSearch() {
    APIService.setTimeOut();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'jwt ' + this.UsuarioLogado.TOKENJWT,
      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': this.API_KEY_SEARCH
    })
  }

  public static  getHeaderResetSenha(token) {
    APIService.setTimeOut();

    // Okay, so the platform is ready and our plugins are available.
    // Here you can do any higher level native things you might need.
    // this.statusBar.styleDefault();
    // this.splashScreen.hide();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': this.API_KEY
    })

  }

  public static LOG_LEVEL = "DEBUG";
  public static ApiCallbackTreatment = {
    next: APIService.parseRequestMessage,
    error: APIService.parseRequestError,
  }

  public static parseRequestMessage(resolve: Function, reject: Function, requestData: any): void
  {
    if(APIService.LOG_LEVEL == 'DEBUG' && window.location.hostname == 'localhost')
    {
      //console.log('*** DEBUG::RESPONSE ->', requestData);
    }

    if(typeof requestData == 'object')
    {
      if(requestData.hasOwnProperty('data') && requestData.hasOwnProperty('cod_erro') && requestData.hasOwnProperty('status_ret'))
      {
        resolve({
          Item: requestData.data,
          erro: requestData.erro
        })
        return;
      }
      else if(requestData.hasOwnProperty('data') && (requestData.hasOwnProperty('version') && requestData['version'] == "ESB") && requestData.hasOwnProperty('status_ret'))
      {
        resolve({
          Item: requestData.data,
          erro: requestData.erro
        })
        return;
      }
    }

    if(Array.isArray(requestData))
    {
      if(requestData.length > 0)
      {
        if(requestData[0].status_ret == "NOK")
        {
          reject({
            Item: null,
            erro: requestData[0].erro || "Não foi possível completar a requisição. Erro desconhecido."
          })
          return;
        }
      }

      resolve({
        Item: requestData,
        erro: ""
      })
    }
    else if(typeof requestData === 'object')
    {
      if(requestData.status_ret == "NOK")
      {
        reject({
          Item: null,
          erro: requestData.erro || "Não foi possível completar a requisição. Erro desconhecido."
        })
        return;
      }
      else if(requestData.status_ret)
      {
        resolve({
          Item: requestData,
          erro: ""
        })
        return;
      }
    }
    else if(typeof requestData === "string")
    {
      resolve({
        Item: requestData,
        erro: ""
      })
      return;
    }

    resolve({
      Item: requestData,
      erro: ""
    })
    return;

  }

  public static parseRequestError(resolve, reject, errorResponse: HttpErrorResponse): void
  {
    if(APIService.LOG_LEVEL == 'DEBUG' && window.location.hostname == 'localhost')
    {
      //console.log('*** DEBUG::ERRO ->', errorResponse);
    }

    if(errorResponse.status == 401)
    {
      reject({
        Item: null,
        erro: "Não foi possível completar a requisição. Acesso negado."
      })
      return;
    }
    else if(Array.isArray(errorResponse.error))
    {
      if(errorResponse.error.length > 0)
      {
        reject({
          Item: null,
          erro: errorResponse.error[0].erro || "Não foi possível completar a requisição. Erro desconhecido."
        })
        return;
      }

      reject({
        Item: null,
        erro: "Não foi possível completar a requisição. Erro desconhecido."
      })
      return;
    }
    else if(typeof errorResponse.error === 'object')
    {
      if(errorResponse.error.status_ret == "NOK")
      {
        reject({
          Item: null,
          erro: errorResponse.error.erro || "Não foi possível completar a requisição. Erro desconhecido."
        })
        return;
      }
      else
      {
        reject({
          Item: null,
          erro: "Não foi possível completar a requisição. Erro desconhecido."
        })
        return;
      }
    }

    reject({
      Item: null,
      erro: "Não foi possível completar a requisição. Erro desconhecido."
    })
    return;

  }



  public static setTimeOut(){
    var dt = new Date();
    dt.setMinutes( dt.getMinutes() + 10 );
    APIService.TIMEOUT=dt;

  }

  /** Monitoração */

  public static gAppInsights;

  public static TelemetriaEventos(pagina, evento, usuario, customData = null) {
    var data;

    if (customData) {
      data = {
        "pagina" : pagina,
        "evento" : evento,
        "data": customData
      }
    } else {
      data = {
        "pagina" : pagina,
        "evento" : evento,
        "nome" : usuario.nomUsuario,
        "usuario" : usuario.login1,
        "email" : usuario.email,
        "tipoUsuario" : usuario.idTipoUsuario,
        "empresa": usuario.contratoLoginPerfils[0].idEmpresa,
        "contrato": usuario.contratoLoginPerfils[0].numContrato
      }
    }
    // console.log(data);
    
    APIService.gAppInsights.trackEvent(pagina, data);
  }

  /**
   *
   * @param cpf string
   * @returns boolean True para CPF válido e False para CPF inválido
   */
  public static ValidaCPF(cpf: string): boolean {
    if (!cpf) return false;

    cpf = cpf.replace(/[\s.-]*/gim, "");

    if (!cpf || cpf.length <= 0) {
      return false;
    } else if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    ) {
      return false;
    }

    var soma = 0;
    var resto;

    for (var i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;

    if (resto != parseInt(cpf.substring(9, 10))) return false;

    soma = 0;

    for (var i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);

    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;

    if (resto != parseInt(cpf.substring(10, 11))) return false;

    return true;
  }

  /**
   * Verifica se o usuário tem acesso ao módulo ou módulo e atividade informada.
   * @param {Object} params - Parameters
   * @param {string} params.id_modulo - ID do módulo.
   * @param {string} params.cod_atividade - Descrição da atividade.
   */
  public static ValidarAcessoUsuario({
    id_modulo,
    cod_atividade,
    idEmpresa = null,
    numContrato = null
  }: {
    id_modulo: MODULOS, cod_atividade?: ATIVIDADES, idEmpresa?: string, numContrato?: string
  }): boolean
  {
    // Verificar se o módulo está no perfil

    if(!id_modulo)
    {
      return false;
    }

    const contratoLoginPerfils = this.UsuarioLogado?.Usuario?.contratoLoginPerfils;
    // //console.log('ValidarAcessoUsuario', id_modulo, cod_atividade, contratoLoginPerfils);

    if(!contratoLoginPerfils)
    {
      // Sem perfis, sem acesso a nada ?
      return false;
    }

    const usuarioLogado = this.UsuarioLogado?.Usuario;

    const localStorageConfig = localStorage.getItem('uc' + APIService.storage_key + usuarioLogado?.login1 + "");
    var shoppingSelecionado = idEmpresa;


    if(!localStorageConfig)
    {
      shoppingSelecionado = contratoLoginPerfils.find(x => x.idEmpresa != 'TODS')?.idEmpresa;

      if(!shoppingSelecionado && contratoLoginPerfils.find(x => x.idEmpresa == 'TODS'))
      {
        shoppingSelecionado = 'TODS';
      }
    }
    else {
      const configUser = new UserConfigDto(JSON.parse(localStorageConfig));

      shoppingSelecionado = idEmpresa ? idEmpresa : configUser.shoppingCod;


      if(!shoppingSelecionado)
      {
        shoppingSelecionado = contratoLoginPerfils.find(x => x.idEmpresa != 'TODS')?.idEmpresa;

        if(!shoppingSelecionado && contratoLoginPerfils.find(x => x.idEmpresa == 'TODS'))
        {
          shoppingSelecionado = 'TODS';
        }
      }

    }


    if(!cod_atividade)
    {
      let temPermissaoModulo = false;

      for(const perfil of contratoLoginPerfils)
      {
        if(Array.isArray(perfil.idPerfilNavigation.ids))
        {

          // Caso o perfil seja TODS(TODOS SHOPPINGS), verifica se a atividade está no módulo;
          if(perfil.idEmpresa === "TODS")
          {
            // Verifica se o módulo está no pefil TODS para acesso do mesmo;
            if(perfil.idPerfilNavigation.ids.findIndex(atividade => atividade.idModulo == id_modulo) != -1)
            {
              temPermissaoModulo = true;
              break;
            }
          }

          // Caso perfil não seja TODS verifica pelos demais shoppings;
          if(perfil.idEmpresa === shoppingSelecionado)
          {

            // Caso o shopping selecionado seja igual a um perfil,
            // filtra as atividades do módulo recebido na função;
            if(perfil.idPerfilNavigation.ids.findIndex(atividade => atividade.idModulo == id_modulo) != -1)
            {
              // Encontrou o módulo no perfil.
              temPermissaoModulo = true;
              break;
            }
          }

        }
      }

      return temPermissaoModulo;
    }
    else
    {

      let temPermissaoTarefa = false;

      for(const perfil of contratoLoginPerfils)
      {
        if(Array.isArray(perfil.idPerfilNavigation.ids))
        {

          // Caso o perfil seja TODS(TODOS SHOPPINGS), verifica se a atividade está no módulo;
          if(perfil.idEmpresa === "TODS")
          {
            // Verifica se a atividade está inserida no perfil;
            if(perfil.idPerfilNavigation.ids.findIndex(atividade => atividade.desAtividade == cod_atividade) != -1)
            {
              temPermissaoTarefa = true;
              break;
            }
          }

          // Verifica se o perfil é igual ao shopping atualmente selecionado;
          if(perfil.idEmpresa === shoppingSelecionado)
          {
            // Filtra as atividades do módulo recebido na função;
            const atividadesPorModulo = perfil.idPerfilNavigation.ids.filter(atividade => atividade.idModulo == id_modulo);

            // Verifica se a atividade está no módulo;
            if(atividadesPorModulo.findIndex(atividade => atividade.desAtividade == cod_atividade) != -1)
            {
              // Encontrou a atividade no perfil.
              temPermissaoTarefa = true;
              break;
            }
          } else {
            // Shopping selecionado não existente nos perfis do usuário;
          }


        }
      }

      return temPermissaoTarefa;
    }
  }

}
